<td class="cell whitespace-nowrap">
	<slot />
</td>

<style>
	.cell {
		padding: 16px;
		/* align-items: center;
		align-self: stretch; */

		color: var(--gray-30, #dbdbdb);

		/* body-B-08 */
		font-size: 14px;
		font-family: Lato;
		font-style: normal;
		font-weight: 700;
		line-height: 140%;
	}
</style>
